import { dashboardAction } from "../actionTypes";
import { Url } from "../../config/config";
import axios from "axios";
import { isLoggedIn } from "../../utils";

//------------------------------------------------DASHBOARD-----------------------------------------------

export const getDashboardInitiate = () => ({
  type: dashboardAction.OWNER_DASHBOARD_INITIATE,
});

export const getDashboardSuccess = (data) => ({
  type: dashboardAction.OWNER_DASHBOARD_SUCCESS,
  payload: data,
});

export const getDashboardFailure = (data) => ({
  type: dashboardAction.OWNER_DASHBOARD_FAILURE,
  payload: data,
});

export function getDashboard(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(getDashboardInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/dashboard`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data.status === 200) {
            dispatch(getDashboardSuccess(data));
          } else if (data.status === 505) {
            dispatch(getDashboardSuccess(data));
          } else {
            dispatch(getDashboardFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(getDashboardFailure(err));
          reject(err);
        }),
    );
  };
}
